import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const initialState = {
  guestToken: '',
};

type TypeGuestTokenStore = {
  /** 비회원 전용 인증 토큰 */
  guestToken: string;
  actions: {
    setGuestToken: (token: string) => void;
    resetGuestToken: () => void;
  };
};

const keyOfStorage = 'guest-token';

/** @description 비회원 인증 토큰을 저장하는 상태 */
export const useGuestTokenStore = create<TypeGuestTokenStore>()(
  persist(
    (set) => ({
      ...initialState,
      actions: {
        setGuestToken: (token: string) => set({ guestToken: token }),
        resetGuestToken: () => {
          set({ ...initialState });
          localStorage.removeItem(keyOfStorage);
        },
      },
    }),
    {
      name: keyOfStorage,
      version: 1,
      partialize: (state) => ({
        guestToken: state.guestToken,
      }),
    }
  )
);
